WiseMetering.Collection.IntegrationPartners = WiseMetering.Collection.extend({
    model: WiseMetering.Model.IntegrationPartner
});

